import { TaskTemplate } from '@/models/task-templates'
import type { TTemplatesState } from '@/types/state-types/TTemplatesState'

export default <TTemplatesState>{
  templateForm: new TaskTemplate(),
  isTemplateFormLoading: false,
  selectedTemplate: { ...new TaskTemplate(), isLoading: false },
  deletingTemplates: false,
  tempTemplate: new TaskTemplate(),
}
